<template>
	<div>
		<div class="page-body">
			<div class="btn-box">
				<el-button type="primary" @click="goadd()">+运费模板</el-button>
			</div>
			
			<div style="height: 2px;background: #DCDFE6;;"></div>
			
			<div :style="!(list.length==0 && !loading) ? 'min-height: 480px' : ''" >
				<el-table class="my-table" v-loading="loading" :data="list">
					<el-table-column label="模板名称" align="left" min-width="80">
						<template slot-scope="scope">
							<div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="计费方式" align="center" min-width="110">
						<template slot-scope="scope">
							{{scope.row.mode_text}}
						</template>
					</el-table-column>
					<el-table-column label="创建时间" align="center">
						<template slot-scope="scope">
							{{scope.row.ctime}}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" min-width="150">
						<template slot-scope="scope">
							<el-button type="text" size="medium" @click="goedit(scope.row.id)">
								编辑
							</el-button>
							<el-button type="text" size="medium" @click="del(scope.$index,scope.row.id,scope.row.name)">
								删除
							</el-button>
							<el-button type="text" size="medium" @click="showRelatedProduct(scope.$index,scope.row.id,scope.row.name)">
								使用情况
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template v-if="count > 0">
				<el-pagination class="my-pagination" background align="center" layout="total, prev, pager, next, jumper" :current-page="currentPage" :total="count" :page-size="pageSize" @current-change="handleCurrentChange">
				</el-pagination>
			</template>
		</div>
		
		
		<dialog-product :show="showDialogPro" :freight_id="freight_id" :template_name="template_name" @close="closeDialogPro" :freight_idx="freight_idx" @remove="removeFreight"></dialog-product>
		
	</div>
</template>

<script>
	import {
		getList,
		getRelatedProductNum,
		delFreightTemplate,
		getRelatedProductInfo
	} from '@/api/freight_template';
	
	import dialogProduct from '@/components/postage/dialog-product.vue';
	
	export default {
		data() {
			return {
				loading: false,
				count: 0,
				list: [],
				pageSize: 10,
				currentPage: 1,
				showDialogPro: false, // 是否显示使用情况
				freight_id:0, // 当前操作的运费模板id
				freight_idx:0, // 当前操作的运费模板下标
				template_name: '', // 当前操作的运费模板名称
			}
		},
		components: {
			dialogProduct
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				localStorage.setItem('keypage', '')
			}
			this.getList();
		},
		methods: {
			// 获取页面信息
			getList() {
				var that = this;
				console.log('刷新');
				that.loading = true;
				getList({
					page: that.currentPage,
					pageSize: that.pageSize
				}).then(res => {
					if (res.code == 0) {
						console.log(res.data);
						that.count = res.data.count;
						that.list = res.data.list;
					} else {
						this.$message.error(res.message);
					}
					that.loading = false;
				})
			},
			// 删除
			del(idx=0,id=0,name){
				// 判断有无关联商品
				getRelatedProductNum({
					freight_id: id
				}).then(r => {
					if(r.code > 0){
						this.$alert('当前运费模版正在被某些商品使用，您可在【使用情况】中查看关联商品并进行管理，当没有商品使用该模板时，您可以选择删除该模板', '提示', {
						  confirmButtonText: '我知道了'
						});
						return;
					}
					
					// 弹出确认框
					this.$confirm('您确认要删除【'+name+'】运费模版吗？', '提示', {
						confirmButtonText: '确认删除',
						cancelButtonText: '取消',
						confirmButtonClass:'confrim-btn'
					}).then(() => {
						delFreightTemplate({
							freight_id: id
						}).then(res => {
							if (res.code == 0) {
								this.list.splice(idx,1);
								this.$message.success(res.message);
							} else {
								this.list.splice(idx,1);
								this.$message.error(res.message);
							}
						})
					}).catch(() => {
					
					});
				})
			},
			// 移除一条数据
			removeFreight(idx){
				console.log(idx);
				this.list.splice(idx,1);
			},
			// 查看使用情况
			showRelatedProduct(idx,id,name){
				this.freight_id = id;
				this.freight_idx = idx;
				console.log(this.freight_idx);
				this.template_name = name;
				this.showDialogPro = true;
			},
			// 关闭使用情况
			closeDialogPro() {
				this.freight_id = 0;
				this.freight_idx = 0;
				this.template_name = '';
				this.showDialogPro = false;
			},
			// 当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			// 添加运费模板
			goadd(){
				this.cachePageinfo();
				this.$router.push({
					path: '/order/postage-add',
					query: {}
				});
			},
			// 编辑运费模板
			goedit(id=0){
				this.cachePageinfo();
				this.$router.push({
					path: '/order/postage-add',
					query: {
						freight_id:id
					}
				});
			},
			// 缓存跳转页面时需要用的信息
			cachePageinfo(){
				localStorage.setItem('keypage', this.currentPage)
			},
		},
	}
</script>

<style scoped="scoped">
	.page-body {
		padding: 10px 10px 30px 10px;
		background: #FFFFFF;
	}
	.btn-box{
		padding: 16px 0 30px 10px;
	}
	.confrim-btn{
		background: #0486FE !important;
	}
</style>